import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
export interface SearchUIContextValue {
  activateFeaturesModal: VoidFunction;
  deactivateFeaturesModal: VoidFunction;
  activateMobileSearchModal: VoidFunction;
  deactivateMobileSearchModal: VoidFunction;
  activateSearchNavForm: VoidFunction;
  deactivateSearchNavForm: VoidFunction;
  featuresModalActive: boolean;
  mobileSearchModalActive: boolean;
  searchNavFormActive: boolean;
}
const SearchUIContext = React.createContext<SearchUIContextValue | undefined>(undefined);
interface SearchUIProviderProps {
  value: SearchUIContextValue;
  children: React.ReactNode;
}
export const SearchUIProvider: React.FC<SearchUIProviderProps> = t0 => {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <SearchUIContext.Provider value={value}>{children}</SearchUIContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useSearchUI = () => {
  const context = React.useContext(SearchUIContext);
  if (context === undefined) {
    throw new Error("useSearchUI must be used within a SearchProvider");
  }
  return context;
};